const electricity_contract = `Hei, Haluan tiedustella sähkösopimusta.
Voisitteko antaa minulle tietoja käytettävissä olevista sopimusvaihtoehdoista,
mukaan lukien hinnat ja ehdot? 
Lisäksi,Haluaisin tietää menettelyn sopimuksen aloittamiseksi.
Kiitos avustanne`;

export default electricity_contract;